export default __webpack_public_path__ + "static/media/mployee-handbook.76f82a04.svg";